document.addEventListener('DOMContentLoaded', function () {
  var openBtn = document.querySelector('[data-modal-open="PasswordModal"]');
  var modal = document.getElementById('PasswordModal');

  if (openBtn && modal && typeof modal.showModal === 'function') {
    openBtn.addEventListener('click', function () {
      modal.showModal();
    });

    modal.querySelectorAll('[data-modal-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.close();
      });
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        modal.close();
      }
    });

    if (modal.querySelector('.sb-form-status--error')) {
      modal.showModal();
    }
  }

  var countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    var launch = new Date(countdown.getAttribute('data-launch')).getTime();
    var daysEl = countdown.querySelector('[data-countdown-days]');
    var hoursEl = countdown.querySelector('[data-countdown-hours]');
    var minutesEl = countdown.querySelector('[data-countdown-minutes]');
    var secondsEl = countdown.querySelector('[data-countdown-seconds]');

    var tick = function () {
      var remaining = launch - Date.now();
      if (isNaN(launch) || remaining <= 0) {
        countdown.hidden = true;
        clearInterval(timer);
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = String(days).padStart(2, '0');
      hoursEl.textContent = String(hours).padStart(2, '0');
      minutesEl.textContent = String(minutes).padStart(2, '0');
      secondsEl.textContent = String(seconds).padStart(2, '0');
    };

    tick();
    var timer = setInterval(tick, 1000);
  }
});
